<div class="field" [formGroup]="formGroup">
    <label class="field__title" [for]="id">{{label ? label : ""}}</label>
    <textarea [id]="id" [placeholder]="placeholder ? placeholder : ''" [rows]="rows" [formControlName]="id"></textarea>

    <form-error [id]="id" [formGroup]="formGroup"></form-error>
</div>